module.exports = __webpack_public_path__ + "img/Support-skill-211.9d22ea2b.png";